import { render, staticRenderFns } from "./salary-preview.vue?vue&type=template&id=0d3ea7d3&scoped=true&"
import script from "./salary-preview.vue?vue&type=script&lang=js&"
export * from "./salary-preview.vue?vue&type=script&lang=js&"
import style0 from "./salary-preview.vue?vue&type=style&index=0&id=0d3ea7d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3ea7d3",
  null
  
)

export default component.exports